module.exports = "pegasus/assets/tech/holiday/101.png";